/// <reference lib="webworker" />
import { VoiceEncoder } from './Voice.encoder';

export enum WorkerMessageType {
  CreateEncoder = 'createEncoder',
  Encode = 'encode',
  FinalBuffer = 'finalBuffer',
  ClearBuffer = 'clearBuffer',
}

export interface VoiceWorkerMessage {
  type: WorkerMessageType;
  data: unknown;
}

export interface VoiceServiceWorkerLocalScope extends ServiceWorkerGlobalScope {
  lameEncoder: VoiceEncoder;
  postMessage(message: VoiceWorkerMessage): void;
  addEventListener: ServiceWorkerGlobalScope['addEventListener'];
}

export interface EncoderConfig {
  sampleRate: number;
  bitRate?: number;
  numberOfChannels?: 1 | 2;
}

export interface IVoiceData {
  file: File;
  histogram: string;
  duration: number;
}
